import { Box, ProgressBar } from '@alf/uikit';
import { progressBarStates } from '../../constants';
import ProgressTitle from './components/ProgressTitle';

import styles from './index.module.css';

const RemainFreeSpinsProgressBar = ({ bonus, status, ...props }) => {
  const { remainCount, freespinCount } = bonus;

  return (
    <Box
      justify="center"
      align="center"
      direction="column"
      className={styles.progressbarWrapper}
      data-testid="remain-free-spins-progress-bar"
    >
      <ProgressTitle bonus={bonus} />
      <ProgressBar
        {...props}
        endValue={freespinCount}
        currentValue={remainCount}
        totalValue={freespinCount}
        progressColor={
          status === progressBarStates.EXPIRED ? 'bg_color_5' : 'accent_color_3'
        }
        classNames={{ containerClassName: styles.freespinsCountProgressBar }}
      />
    </Box>
  );
};

export default RemainFreeSpinsProgressBar;
